export default function getTimeSince(datetime) {
    const today = new Date(Date.now());
    datetime = new Date(datetime);

    // Calculating the time difference between two dates
    const diffInTime = today.getTime() - datetime.getTime();

    // One day in milliseconds
    const oneYear = 1000 * 60 * 60 * 24 * 365;

    // Calculating the no. of days between two dates
    const diffInYears = Math.floor(diffInTime / oneYear);

    if(diffInYears >= 1){
        return datetime.toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"})
        return diffInYears + ' years ago';
    }

    // One day in milliseconds
    const oneMonth = 1000 * 60 * 60 * 24 * 31;

    // Calculating the no. of days between two dates
    const diffInMonths = Math.floor(diffInTime / oneMonth);

    if(diffInMonths >= 1){        
        return datetime.toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"})
        return diffInMonths + ' months ago';
    }

    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the no. of days between two dates
    const diffInDays = Math.floor(diffInTime / oneDay);

    if(diffInDays >= 1){
        return diffInDays + ' days ago';
    }

    const oneHour = 1000 * 60 * 60;
    // Calculating the no. of hours between two dates
    const diffInHours = Math.floor(diffInTime / oneHour);

    if(diffInHours > 1){
        return diffInHours + ' hours ago';
    }


    const oneMinute = 1000 * 60;
    // Calculating the no. of minutes between two dates
    const diffInMinutes = Math.floor(diffInTime / oneMinute);
    return diffInMinutes + ' minutes ago';


}